import { React } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Dashboard from './pages/dashboard'
import Businesses from './pages/businesses';
import Properties from './pages/properties';
import Characters from './pages/characters';
import CharacterPage from './pages/character';
import Government from './pages/government';
import Staffapp from './pages/applications/staff';
import Developerapp from './pages/applications/developer';
import Testapp from './pages/applications/tester';
import Buisnessinfo from './pages/Buisnessinfo';
import PropertyInfo from './pages/Propertyinfo';
import RoleBasedRoute from './components/RoleBasedRoute';
import AdminDashboard from './pages/admin';
import RealtorTools from './pages/RealtorTools';
import UploadImage from './pages/UploadImage';
import { NotificationProvider } from './context/NotificationContext';
import Notification from './components/Notification';

function App() {
  return (
    <NotificationProvider>
      <Router>
        <Notification />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pages/dashboard" 
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <Dashboard />
              </RoleBasedRoute>
            }
          />
          <Route path="/pages/businesses"
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <Businesses />
              </RoleBasedRoute>
            }
          />
          <Route path="/pages/properties"
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <Properties />
              </RoleBasedRoute>
            }
          />
          <Route path="/pages/characters" 
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <Characters />
              </RoleBasedRoute>
          } />
          <Route path="/pages/character" 
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <CharacterPage />
              </RoleBasedRoute>
          } />
          <Route path="/pages/government" 
            element={
              <RoleBasedRoute allowedRoles={['admin']}>
                <Government />
              </RoleBasedRoute>
            } />
          <Route path="/pages/applications/staff" 
            element={
              <RoleBasedRoute allowedRoles={['admin']}>
                <Staffapp />
              </RoleBasedRoute>
            } />
          <Route path="/pages/applications/developer" 
            element={
              <RoleBasedRoute allowedRoles={['admin']}>
                <Developerapp />
              </RoleBasedRoute>
            } />
          <Route path="/pages/applications/tester" 
            element={
              <RoleBasedRoute allowedRoles={['admin']}>
                <Testapp />
              </RoleBasedRoute>
            } />
          <Route path="/buisnessinfo/:id"
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <Buisnessinfo />
              </RoleBasedRoute>
            } />
          <Route path="/propertyinfo/:id"
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <PropertyInfo />
              </RoleBasedRoute>
            } />
          <Route path="/pages/admin"
            element={
              <RoleBasedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </RoleBasedRoute>
            } />
          <Route path="/pages/realtortools"
            element={
              <RoleBasedRoute allowedRoles={['admin', 'realtor']}>
                <RealtorTools />
              </RoleBasedRoute>
            } />
          <Route path="/pages/upload"
            element={
              <RoleBasedRoute allowedRoles={['user', 'admin', 'realtor']}>
                <UploadImage />
              </RoleBasedRoute>
            } />
        </Routes>
      </Router>
    </NotificationProvider>
  )
}

export default App